// extracted by css-extract-rspack-plugin
export default {"transitionThemeChange":"QjQnf"};